import React, { forwardRef, useRef } from 'react'
import { CSSTransition } from 'react-transition-group'
import { Text } from '@chakra-ui/react'

import { DateButton } from './components/Buttons/DateButton'
import { TimeButton } from './components/Buttons/TimeButton'
import { DatePicker } from './components/DatePicker'
import { DateTimePickerLoader } from './components/DateTimePickerLoader'
import { TimePicker } from './components/TimePicker'
import { DateTimePickerContext, useDateTimePickerLogic } from './helpers'
import { DateTimePickerHandle, DateTimePickerProps } from './interfaces'
import { DateTimePickerButtonsWrapper, DateTimePickerWrapper, PickersContent, PickersWrapper } from './styles'

export const DateTimePicker = forwardRef<DateTimePickerHandle, DateTimePickerProps>(function DateTimePicker(
  props,
  ref,
) {
  const [dateTimeState, setDateTimeState] = useDateTimePickerLogic(props, ref)
  const pickersContentRef = useRef<HTMLDivElement>(null)
  const nodeRef = useRef<HTMLDivElement>(null)

  const { isExpanded } = dateTimeState
  const { title, disabled } = props

  return (
    <DateTimePickerContext.Provider value={{ dateTimeState, setDateTimeState }}>
      <DateTimePickerWrapper disabled={disabled}>
        <Text fontSize="md" marginBottom="16px">
          {title}
        </Text>
        <DateTimePickerButtonsWrapper>
          <DateButton />
          <TimeButton />
        </DateTimePickerButtonsWrapper>
        <CSSTransition nodeRef={nodeRef} in={!isExpanded} classNames="collapse" timeout={300}>
          <PickersWrapper
            ref={nodeRef}
            pickersContentRef={pickersContentRef}
            defaultCollapsed={props.defaultCollapsed}
            isExpanded={isExpanded}
          >
            <PickersContent ref={pickersContentRef}>
              <DatePicker />
              <TimePicker />
              <DateTimePickerLoader />
            </PickersContent>
          </PickersWrapper>
        </CSSTransition>
      </DateTimePickerWrapper>
    </DateTimePickerContext.Provider>
  )
})
